
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
// import { Link } from 'react-router-dom';
import TimeAgo from "react-timeago";
import Icon from '@material-ui/core/Icon';
import ReactPlayer from 'react-player';
import Lazyload from 'react-lazyload';
import styled from 'styled-components';
import { Link } from "routes";
import {
  BrowserView,
  TabletView,
  MobileOnlyView
} from "react-device-detect";
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';

const styles = (theme, props) => ({
  thumb:{

  },
  teaser: {
    
  },
    root: {
        // display: 'flex',
        // flexWrap: 'wrap',
        // justifyContent: 'space-around',
        // overflow: 'hidden',
        // backgroundColor: theme.palette.background.paper,
        width: '100%',
    },

    layout: {
      margin: '-3px auto -3px',
      [theme.breakpoints.up('md')]: {
        width: 1000,
      },
      [theme.breakpoints.only('md')]: {
        width: 900,
      },
      [theme.breakpoints.only('sm')]: {
        width: 650
      },
     
    },
    img:{
      background: "url('https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image-1000x500.png') no-repeat center center",
      // backgroundSize: '100%',
      // background: "url('https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image.jpg') no-repeat 50% 50% center center",
        // background: 'linear-gradient(0deg,rgba(0, 0, 0, 0.63) 10%,rgba(0, 0, 0, 0.51) 20%,rgba(0, 0, 0, 0.44) 20%,transparent)',
        width: '100%',
        height: 232,
        objectFit: 'cover',
        [theme.breakpoints.up('md')]: {
          height: 400,
        },
        [theme.breakpoints.only('sm')]: {
          height: 300,
        }
    },
    gridList: {
      display: 'inline-block',
      width: '100%',
      // height: 241,
      height: 244,
      [theme.breakpoints.up('md')]: {
        // height: 410,
        height: 412
      },
      [theme.breakpoints.only('sm')]: {
        height: 310,
      },
      
  },
    titleBar: {
        backgroundColor: 'transparent',
        height: 'auto',
        marginBottom: 30,
    },
    title: {
        lineHeight: 1.2

    },
    cateStyle: {
        display: 'inline',
        float: 'left',
        padding: '4px 8px',
        margin: '0px 0px 8px',
        fontSize: 10,
        borderRadius: 3,
        marginLeft: 17,
        backgroundColor: '#fff'
    },
    newsTitle:{
        fontSize: 20,
        color: 'hsla(0,0%,100%,.92)',
        lineHeight: '38px',
        display: 'inline',  
        whiteSpace: 'initial',
        padding: '8px 0px'
    },

    time: {
        color: '#fff',
        position: 'absolute',
        bottom: 8,
        left: 10,
        fontSize: 12,
        display: 'inline',
        padding: '3px 0px 5px 0px',
        margin: '-3px 8px',
        // boxShadow: '-8px 0 0 0 #212121, 8px 0 0 0 #212121',
        whiteSpace: 'initial',
        // backgroundColor: '#212121',
    },
    timeIcon: {
        paddingRight: 5,
        fontSize: 12,
    },
    titleWrap: {
        marginLeft: 0,
    },
    subtitle: {
        paddingLeft: 25
    },
    reactPlayer:{
      position: 'absolute',
      top: 0,
      left: 0
    },
    playerWrapper: {
      position: 'relative',
      [theme.breakpoints.only('xs')]: {
        height: '232px',
      },
      [theme.breakpoints.only('sm')]: {
        height: '300px',
      },
      [theme.breakpoints.up('md')]: {
        height: '348px',
      },
      
    },
    date: {
      marginLeft: 5
    },
    shadow: {
      '&::before': {
        content: '""',
        width: '100%',
        position: 'absolute',
        // bottom: 4,
        bottom: 8,
        left: 0,
        height: 50,
        background: 'linear-gradient(0deg,rgba(0, 0, 0, 0.63) 20%,rgba(0, 0, 0, 0.51) 40%,rgba(0, 0, 0, 0.44) 49%,transparent)'
    },
    },
    brandBadgeWrapper:{
      position: 'absolute',
      right: 12,
      top: -6,
      textAlign: 'center',
      zIndex: 1,
    },
    brandBadge: {
      background: '#fff',
      color: '#ff9803',
      borderRadius: '0px 0px 7px 7px',
      border: '1px solid #e9e9e9',
      minHeight: '28px',
      width: 68,
      display: 'inline-block',
      overflow: 'hidden'
    },
    forBefore: {
      position: 'relative',
      '&::before':{
        content: "''",
        position: 'absolute',
        borderRight: '10px solid #abacac',
        borderTop: '8px solid transparent',
        right: 80,
        top: -6,
      }
    }
});

class NewsItem extends React.Component{
    render(){
        const { classes, item, mainCategory } = this.props;
        // const categoryRoute = item.category.path.split('/')[1];
        const color = item.category.color;
        const box = () => `-8px 0 0 0 ${color}, 8px 0 0 0 ${color}`
        const TitleStyle = styled.span`
            background: ${color};
            box-shadow: ${box} ;
        `;
   
        return (
          <div className={classes.root}>
            <div className={classes.layout} >
            {item.sponsor != null? <div className={classes.forBefore}>
              <div className={classes.brandBadgeWrapper}>
                <div className={classes.brandBadge}>
                  <Link route="brandProfile" params={{ brandProfile: item.sponsor.slug }}>
                    <img src={item.sponsor.logo} style={{width: '68px', height: 'auto', verticalAlign: 'middle'}} alt=""/>
                  </Link>
                </div>
              </div>
            </div>: null}
              <Lazyload
                throttle={200}
                height={300}
                // placeholder={<Placeholder />}
                offset={100}
              >    
             
                <GridList cellHeight='auto' cols={1} rows={1} className={classes.gridList}>
                  <GridListTile key={this.props.id} style={{padding: 0}}>
                    <div className={classes.shadow}>
                      <MobileOnlyView>
                        {item.type === 'VIDEO' ? 
                          (item.video ?
                            <div className={classes.playerWrapper}>
                              <ReactPlayer
                                url={item.video}
                                playing
                                width='100%'
                                height='100%'
                                muted
                                className={classes.reactPlayer}
                              />
                            </div>
                            :
                            <Link route={`${item.path}`}>
                              <img className={classes.img} style={{ cursor: 'pointer' }} src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-video-1000x500.png" alt="Duwun Logo" /> 
                            </Link>
                              ): 
                              (item.cover.thumb ?
                                <div className={classes.thumb}>
                                  {/* {console.log('thumb')} */}
                                  <Link route={`${item.path}`}>
                                    <img className={classes.img} style={{ cursor: 'pointer' }} src={item.cover.thumb} alt="" />
                                  </Link>
                                </div>
                                  : 
                                <Link route={`${item.path}`}>
                                  <img className={classes.img} style={{ cursor: 'pointer' }} src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image-1000x500.png" alt="Duwun Logo" />
                                </Link>
                            )
                        }
                      </MobileOnlyView>
                      <TabletView>
                        {item.type === 'VIDEO' ? 
                          (item.video ?
                            <div className={classes.playerWrapper}>
                              <ReactPlayer
                                url={item.video}
                                playing
                                width='100%'
                                height='100%'
                                muted
                                className={classes.reactPlayer}
                              />
                            </div>
                            :
                            <Link route={`${item.path}`}>
                              <img className={classes.img} style={{ cursor: 'pointer' }} src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-video-1000x500.png" alt="Duwun Logo" /> 
                            </Link>
                              ): 
                              (item.cover.teaser ?
                                <div className={classes.teaser}>
                                  {/* {console.log('teaser')} */}
                                  <Link route={`${item.path}`}>
                                    <img className={classes.img} style={{ cursor: 'pointer' }} src={item.cover.teaser} alt="" />
                                  </Link>
                                </div>
                                  : 
                                <Link route={`${item.path}`}>
                                  <img className={classes.img} style={{ cursor: 'pointer' }} src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image-1000x500.png" alt="Duwun Logo" />
                                </Link>
                            )
                        }
                      </TabletView>
                      <BrowserView>
                        {item.type === 'VIDEO' ? 
                          (item.video ?
                            <div className={classes.playerWrapper}>
                              <ReactPlayer
                                url={item.video}
                                playing
                                width='100%'
                                height='100%'
                                muted
                                className={classes.reactPlayer}
                              />
                            </div>
                            :
                            <Link route={`${item.path}`}>
                              <img className={classes.img} style={{ cursor: 'pointer' }} src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-video-1000x500.png" alt="Duwun Logo" /> 
                            </Link>
                              ): 
                              (item.cover.teaser ?
                                <div className={classes.teaser}>
                                  {/* {console.log('teaser')} */}
                                  <Link route={`${item.path}`}>
                                    <img className={classes.img} style={{ cursor: 'pointer' }} src={item.cover.teaser} alt="" />
                                  </Link>
                                </div>
                                  : 
                                <Link route={`${item.path}`}>
                                  <img className={classes.img} style={{ cursor: 'pointer' }} src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image-1000x500.png" alt="Duwun Logo" />
                                </Link>
                            )
                        }
                      </BrowserView>
                        <GridListTileBar
                          style={{ cursor: 'pointer' }}
                          classes={{
                          title: classes.title,
                          titleWrap: classes.titleWrap,
                          subtitle: classes.subtitle
                        }}
                          subtitle={
                            <Link route={`${item.path}`}>
                              <TitleStyle className={classes.newsTitle}>{fontUniOrConvertZawgyi(item.title)}</TitleStyle>                  
                            </Link>
                     }
                          title={ 
                            <div className="category-tag-gtm">
                              <Link route={`${item.category.path}`}>
                              <span
                                  className={classes.cateStyle}
                                  style={{
                                  color: item.category.color
                                  }}>{ item.category.name }
                              </span>
                            </Link>            
                          </div>
                      }
                          titlePosition="bottom"
                          actionPosition="left"
                          className={classes.titleBar}
                        />
                    
                      <Link route={`${item.path}`}>
                        <div className={classes.time} style={{ cursor: 'pointer' }}>
                          <Icon className={classes.timeIcon}>access_time</Icon>
                          <TimeAgo className={classes.date} date={new Date(item.published_date.date)} />
                        </div>
                      </Link>
                    </div>
                  </GridListTile>
                </GridList>
              </Lazyload> 
            </div>
          </div>
        );
        
    }
}


NewsItem.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NewsItem);
